Apt.fn.make('account.listing', {
	/**
	 * Initialize module
	 */
	init() {
		const priv = this.$private;

		priv.id = $.context('id');

		priv.initPreview();

		LS.util.load('account-post');
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('listing', this.$private, [
			'calls',
			'history',
			'messages',
			'metrics',
			'preview',
			'tabs'
		]);
	}
}, {
	/**
	 * Initialize preview
	 */
	initPreview() {
		const scope = this;

		LS.api.get(`me/listings/${scope.id}/detail`, {
			auth: true,
			success: listing => {
				scope.approved = listing.approved;

				Apt.properties.transform(listing, 1);

				Apt['account.listings'].transform(listing);

				scope.data = listing;

				scope.preview = $.app.make('post', {
					view: $$('previewTemplate')[0].textContent,
					target: '$detail',
					model: listing
				});

				scope.initTabs();

				Apt['account.listings'].initAction(scope.preview, 'listing');
			}
		});
	},

	/**
	 * Initialize tabs
	 */
	initTabs() {
		const scope = this;
		const init = {};

		scope.tabs = Apt.fn.tab().init('$tabs', id => {
			if (init[id]) {
				return;
			}

			init[id] = true;

			scope['init' + LS.util.capitalize(id)]();
		});
	},

	/**
	 * Initialize messages
	 */
	initMessages() {
		const scope = this;

		LS.util.load('account-messages', () => {
			scope.messages = Apt.fn['account.messages']()
				.init({
					path: 'me/listings/' + scope.id,
					empty: "This listing hasn't received any messages yet.",
					sender: true,
					target: false
				});

			$$('listingDetails').show();
		});
	},

	/**
	 * Initialize calls
	 */
	initCalls() {
		const scope = this;

		LS.util.load('account-calls', () => {
			scope.calls = Apt.fn['account.calls']()
				.init({
					path: 'me/listings/' + scope.id,
					empty: "This listing hasn't received any calls yet.",
					caller: true,
					target: false
				});

			$$('listingDetails').show();
		});
	},

	/**
	 * Initialize metrics
	 */
	initMetrics() {
		const scope = this;

		LS.util.load('account-metrics', () => {
			scope.metrics = Apt.fn['account.metrics']()
				.init({
					path: 'me/listings/' + scope.id
				});
		});
	},

	/**
	 * Initialize history
	 */
	initHistory() {
		const scope = this;
		const $target = $$('history');

		scope.history = Apt.fn.index().init({
			auth: true,
			target: $target,
			view: $$('historyTemplate')[0].textContent,
			event: false,
			resource: 'me/listings/' + scope.id + '/logs',
			paginate: true,
			params: {
				limit: 10,
				sort: '-newest'
			},
			transform: log => {
				log.processed_at = LS.util.localize(log.processed_at)
					.toISOString();
			}
		});
	}
});